export default __webpack_public_path__ + "static/media/product31_slides.a019510b.webp";